import React, { useState } from 'react';
import { Button } from '../shared/Button';
import { Card } from '../shared/Card';
import { ConsistencyTracker } from './ConsistencyTracker';
import { ExerciseTrends } from './ExerciseTrends';
import { AIInsights } from './AIInsights';
import { MinutesProgressChart } from './MinutesProgressChart';
interface ProgressDashboardProps {
  navigateTo: (screen: string) => void;
}
export const ProgressDashboard = ({
  navigateTo
}: ProgressDashboardProps) => {
  return <div className="flex flex-col h-full min-h-screen bg-white pb-16" data-id="element-1405">
      <div className="p-6 border-b border-gray-100" data-id="element-1406">
        <div className="flex justify-between items-center mb-4" data-id="element-1407">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-1408">Your Progress</h1>
          <div className="w-6" data-id="element-1409"></div> {/* Empty div for flex alignment */}
        </div>
      </div>
      <div className="flex-1 p-6 space-y-6 overflow-y-auto" data-id="element-1410">
        <ConsistencyTracker data-id="element-1411" />
        <MinutesProgressChart data-id="element-1412" />
        <ExerciseTrends data-id="element-1413" />
        <AIInsights data-id="element-1414" />
      </div>
    </div>;
};